import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import { LogMeOut, updateAuthentication } from "Actions/AuthenticationAction";
import { instance } from "Actions/AxiosInstance";
import axios from "axios";
import {
  clockin,
  CommonReducerAction,
  PushNotificationActive,
  SetAppMode,
  SetDrawerID,
} from "Actions/commonAction";
import {
  SetSubscriptionData,
  VerifySubscription,
} from "Actions/SubscriptionInfo";
import ChangePassword from "Component/ChangePassword";
import If from "Component/Common/If";
import DirectoryDrawer from "Component/HelpertextDrawer/DirectoryDrawer";
import Loader from "Component/Loader";
import MobileView from "Component/MobileView";
import Navigation from "Component/Navigation/Navigation";
import { ReducersTypes } from "Constants";
import Configs from "Constants/Configs";
import firebase from "Constants/FirebaseConfig";
import { EXACTROUTES, INCLUDEROUTES } from "Constants/Navigation";
import { NavigationOnPath } from "Constants/NavigationOnPath";
import { getSubdomain } from "Handlers/getters";
import { setAppFavicon, setFullStory } from "Handlers/setters";
import get from "lodash/get";
import ChangePwdTab from "Module/Accounts/ChangePassword/ChangePasswordTab";
import DownloadInvoice from "Module/LogIn/DownloadInvoice/DownloadInvoice";
import DownloadPayslip from "Module/LogIn/DownloadPayslip/DownloadPayslip";
import LogInAsAdmin from "Module/LogIn/LogInAsAdmin/LogInAsAdmin";
import LogInAsSSO from "Module/LogIn/LoginAsSSO/LogInAsSSO";
import SubscriptionApp from "Module/LogIn/SubscriptionApp";
import SubscriptionExpiredPage from "Module/LogIn/SubscriptionExpiredPage";
import SubscriptionForgotPassword from "Module/LogIn/SubscriptionForgotPassword/SubscriptionForgotPassword";
import TrialExpiredPage from "Module/LogIn/TrialExpiredPage";
import TypoError from "Module/LogIn/TypoError";
import UpdateSubscriptionPassword from "Module/LogIn/UpdateSubscriptionPassword/UpdateSubscriptionPassword";
import Storybook from "Module/Storybook";
import Calendar from "Module/Subscription/Calendar";
import CommonNavbar from "Module/Subscription/CommonLayout/Navbar";
import ConfigMode from "Module/Subscription/ConfigMode";
import ExpenseDashboard from "Module/Subscription/ConfigMode/Pay/Expense/Dashboard/ExpenseDashboard";
import Checklist from "Module/Subscription/ConfigMode/Resolve/Checklist/Employee/index";
import PolicyCenter from "Module/Subscription/ConfigMode/Resolve/PolicyCenter/EmpPolicyCenter";
import ConfigRoutes from "Module/Subscription/configRoutes";
import DailyRequests from "Module/Subscription/DailyRequests";
import Directory from "Module/Subscription/Directory/Directory";
import BasicEmpProfile from "Module/Subscription/EmpProfile/BasicEmpProfile";
import EmpProfileBeforeJoining from "Module/Subscription/EmpProfile/EmpMainProfile/EmpProfileBeforeJoining";
import MainProfilePage from "Module/Subscription/EmpProfile/EmpMainProfile/MainProfilePage";
import InviteEmployee from "Module/Subscription/EmpProfile/InviteEmployee";
import ProfileLandingPage from "Module/Subscription/EmpProfile/profileLandingPage";
import ProfilePrivacy from "Module/Subscription/EmpProfile/ProfilePrivacy";
import Help from "Module/Subscription/Help";
import Home from "Module/Subscription/Home";
import HrisDashboard from "Module/Subscription/Home/hris";
import tt from "Module/Subscription/Home/trailkeys";
import HrDrive from "Module/Subscription/HrDrive";
import MyHrLetters from "Module/Subscription/HrLetters/MyHrLetters";
import Assets from "Module/Subscription/Hrops/Assets";
import Helpdesk from "Module/Subscription/Hrops/Helpdesk/Employee/index";
import HelpdeskManager from "Module/Subscription/Hrops/Helpdesk/Manager/index";
import NotificationCenter from "Module/Subscription/Notifications/NotificationCenter";
import NotificationSettings from "Module/Subscription/Notifications/NotificationSettings";
import Offercenter from "Module/Subscription/Offercenter";
// import LiveDataRoute from "Module/Subscription/LiveData/livedata";
// import PlannerRoute from "Module/Subscription/Planner/Route";
import MyGoals from "Module/Subscription/Okrs";
import OrganisationRoutes from "Module/Subscription/organiseRoutes";
import EmpPayroll from "Module/Subscription/Payroll/EmpPayroll";
import payrollRoutess from "Module/Subscription/payrollRoutes";
import Review from "Module/Subscription/Perform/360DegreeReview/Employee/360degreereview";
import ReviewManager from "Module/Subscription/Perform/360DegreeReview/Manager/index";
import performRoutes from "Module/Subscription/performRoutes";
import Operations from "Module/Subscription/Planner/operations";
import Recruit from "Module/Subscription/Recruit/index";
import SubscriptionCareerPage from "Module/Subscription/Recruit/SubscriptionCareerPage";
import Reportee from "Module/Subscription/Reportee";
import ReportRobo from "Module/Subscription/ReportRobo";
import RequestCenter from "Module/Subscription/ReqCenter";
import ChecklistManager from "Module/Subscription/Resolve/Checklist";
import Attendance from "Module/Subscription/Track/Attendance/AttendanceLog";
import Holiday from "Module/Subscription/Track/Holiday";
import SelectOptionalHoliday from "Module/Subscription/Track/Holiday/SelectOptionalHoliday";
import Leaves from "Module/Subscription/Track/Leaves/LeaveBalance";
import OKR from "Module/Subscription/Perform/Okrs";
// import FCMNotification from "Component/FCMNotification";
// import RightNavigation from "Component/Navigation/RightNavigation";
// import BioMetric from "Module/Subscription/Biometric";
// import Track from "Module/Subscription/Track";
// const ConfigRoutes = p => <C Child={<ConfigRoutesComp {...p} />} />;
// import LogRocket from "logrocket";
// import HrisDashboard from "Component/BarChart";
import { withSnackbar } from "notistack";
import React, { lazy, Suspense } from "react";
import { connect } from "react-redux";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  withRouter,
} from "react-router-dom";
import { bindActionCreators } from "redux";

// import BeaconDevTools from '@helpscout/beacon-devtools';

const TrackComp = lazy(() => import("Module/Subscription/Track"));
const PlannerRouteComp = lazy(() =>
  import("Module/Subscription/Planner/Route"),
);
const LiveDataRouteComp = lazy(() =>
  import("Module/Subscription/LiveData/livedata"),
);
// const ConfigRoutesComp = lazy(() => import("Module/Subscription/configRoutes"));

const C = (p) => <Suspense fallback={<Loader />}>{p.Child}</Suspense>;

const Track = (p) => <C Child={<TrackComp {...p} />} />;
const PlannerRoute = (p) => <C Child={<PlannerRouteComp {...p} />} />;
const LiveDataRoute = (p) => <C Child={<LiveDataRouteComp {...p} />} />;
// LogRocket.init("xc0tpk/sumhr-dev");

const Comingsoon = () => (
  <div className="coming-soon">
    <span>Coming soon...</span>
  </div>
);

const PARAMS = {
  variant: "success",
  anchorOrigin: {
    vertical: "top",
    horizontal: "center",
  },
};

class RootContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      clockintime: "",
      enoughDataReceived: false,
      notificationcount: 0,
      typoperrorcode: false,
      ishiringmanager: false,
      ishiringowner: false,
      isrecruiter: false,
      isparticipant: false,
      checkrecruitaccessapi: false,
      chechelpdeskaccessapi: false,
      isticketowner: false,
    };
    this.authenticateUser = this.authenticateUser.bind(this);
    this.authenticateSubscription = this.authenticateSubscription.bind(this);
    this.setMessagingListner = this.setMessagingListner.bind(this);
    this._showLeftDrawer = this._showLeftDrawer.bind(this);
    this._showRightDrawer = this._showRightDrawer.bind(this);
    this.storageChange = this.storageChange.bind(this);
    this.setEnoughDataReceivedFlag = this.setEnoughDataReceivedFlag.bind(this);
    this.setFirebase = this.setFirebase.bind(this);
    this.setConfigMode = this.setConfigMode.bind(this);
    this.setNotification = this.setNotification.bind(this);
    this.getClockIn = this.getClockIn.bind(this);
    this.FCMLogoutEvent = this.FCMLogoutEvent.bind(this);
  this.beaconConfiguartion = this.beaconConfiguartion.bind(this);
  }

  beaconConfiguartion(){
    const helpscoutRelevantArticles = axios({
      method: 'get',
      url: 'https://docsapi.helpscout.net/v1/collections/65128ba7d34bd506b41bf585/articles',
      auth: {
        username: 'a9349fbd93fcef84f3051c28c91eecb6a3b23ae0',
        password: 'X'
      }
    })
    .then(response => {
     
      const itemIds = response.data.articles.items.slice(0, 10).map(item => item.id);
    this.setState({helpscoutarticleids:itemIds});
    })
    .catch(error => {
      console.error(error);
    });
  }

  setSelectedDrawerIDOnURL = () => {
    const path = window.location.pathname;
    if (path) this.props.SetDrawerID(NavigationOnPath[path]);
  };

  componentDidMount() {
   this.beaconConfiguartion();

   if (Configs.MODE === "PROD") {

    (function (c, l, a, r, i, t, y) {
      c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments) };
      t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i;
      y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
    })(window, document, "clarity", "script", "lrotux4dq4");

    clarity("set", "userID", this.props && this.props.AuthenticationAction && this.props.AuthenticationAction.login && this.props.AuthenticationAction.login.email && this.props.AuthenticationAction.login.email);
    clarity("set", "pageID", this.props && this.props.SubscriptionInfo && this.props.SubscriptionInfo.SubscriptionData && this.props.SubscriptionInfo.SubscriptionData.subdomain && this.props.SubscriptionInfo.SubscriptionData.subdomain);


  } else {

    (function (c, l, a, r, i, t, y) {
      c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments) };
      t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i;
      y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
    })(window, document, "clarity", "script", "lrov50idtq");

    clarity("set", "userID", this.props && this.props.AuthenticationAction && this.props.AuthenticationAction.login && this.props.AuthenticationAction.login.email && this.props.AuthenticationAction.login.email);
    clarity("set", "pageID", this.props && this.props.SubscriptionInfo && this.props.SubscriptionInfo.SubscriptionData && this.props.SubscriptionInfo.SubscriptionData.subdomain && this.props.SubscriptionInfo.SubscriptionData.subdomain);

  }

    this.setSelectedDrawerIDOnURL();
    // const prev = window.localStorage.getItem("prevLink");

    // if (prev && prev.includes("request_center")) {
    //   window.open(prev, "_self");
    // }

    setTimeout(() => {
      this.authenticateSubscription();
      this.authenticateUser();
    }, 200);

    this.getNotificationCount();
    // this.authenticateSubscription();
    // this.authenticateUser();
    this.setConfigMode();
    this.setFirebase();
    this.checkrecruitaccess();
    this.checkhelpdeskaccess();

    window.addEventListener("storage", this.storageChange, false);
    // setFullStory(
    //   get(this.props, "SubscriptionInfo.SubscriptionData.accountid", ""),
    // );
    navigator.serviceWorker &&
      navigator.serviceWorker.addEventListener("message", (event) => {
        this.FCMLogoutEvent(event);
      });
  }

  FCMLogoutEvent(event) {
    if (event.data["firebase-messaging-msg-data"].data.key == "SIGNOUT") {
      setTimeout(() => {
        this.props.LogMeOut(
          get(this.props, "AuthenticationAction.login.userid", ""),
        );
      }, 2000);
    }
  }

  checkrecruitaccess() {
    instance
      .get("/recruit/checkrecruitaccess")
      .then((resp) => {
        this.setState({
          ishiringmanager: resp.data.result[0].ishiringmanager,
          ishiringowner: resp.data.result[0].ishiringowner,
          isrecruiter: resp.data.result[0].isrecruiter,
          isparticipant: resp.data.result[0].isparticipant,
          checkrecruitaccessapi: true,
        });
      })
      .catch((error) => {
        this.setState({ checkrecruitaccessapi: true });
      });
  }

  checkhelpdeskaccess() {
    instance
      .get("/helpdesk/checkhelpdeskaccess")
      .then((resp) => {
        this.setState({
          isticketowner: resp.data.result[0].isticketowner,

          chechelpdeskaccessapi: true,
        });
      })
      .catch((error) => {
        this.setState({ chechelpdeskaccessapi: true });
      });
  }

  componentWillReceiveProps() {
    this.getNotificationCount();
    this.getClockIn();
  }

  getClockIn() {
    instance
      .post("attendance/allpunchlogbyempid", { shiftdate: new Date() })
      .then((resp) => {
        this.props.clockin(resp.data.result);
      });
  }

  getNotificationCount() {
    instance
      .get("subscription/getnotificationcount")
      .then((result) => {
        this.setState({
          notificationcount: result.data.result[0]
            ? result.data.result[0].newnotificationcount
            : 0,
        });
      })
      .catch((error) => {
        console.log("error: ", error);
      });
  }

  setNotification() {
    this.setState({
      notificationcount: 0,
    });
  }

  componentWillUnmount() {
    try {
      window.removeEventListener("storage");
    } catch (e) {}
    window.removeEventListener("storage", this.storageChange, false);
  }

  setConfigMode() {
    let isconfig = false;
    ["/config"].forEach((path) => {
      if (window.location.pathname.indexOf(path) > -1) {
        isconfig = true;
      }
    });
    sessionStorage.setItem("appMode", isconfig ? "config" : "normal");
    if (isconfig) {
      this.props.SetAppMode("config");
    } else {
      this.props.SetAppMode("normal");
    }
  }

  setFirebase() {
    try {
      const setDeviceToken = () => {
        firebase
          .messaging()
          .getToken()
          .then((currentToken) => {
            if (get(this.props, "AuthenticationAction.login", "")) {
              return instance
                .post("subscription/updatedevicetoken", {
                  devicetokenid: currentToken,
                })
                .then(() => {
                  this.props.CommonReducerAction(ReducersTypes.FCM, {
                    devicetokenid: currentToken,
                  });
                  this.setMessagingListner();
                });
            }
            this.props.CommonReducerAction(ReducersTypes.FCM, {
              devicetokenid: currentToken,
            });
          });
      };
      // if (Notification.permission !== "granted") {
      //   Notification.requestPermission().then((permission) => {
      //     if (permission === "granted") {
      //       setDeviceToken();
      //     }
      //   });
      // } else if (!get(this.props, "FCMReducer.devicetokenid", "")) {
      //   setDeviceToken();
      // } else {
      //   setDeviceToken();
      // }
      if (Notification.permission !== "granted") {
        Notification.requestPermission().then((permission) => {
          if (permission === "granted") {
            setDeviceToken();
          }
        });
      } else {
        setDeviceToken();
      }
    } catch (err) {}
  }

  setEnoughDataReceivedFlag(enoughDataReceived) {
    this.setState({ enoughDataReceived });
  }

  setMessagingListner() {
    try {
      const messaging = firebase.messaging();
      console.log("messaging: ", messaging);
      messaging.onMessage((payload) => {
        console.log("payload: ", payload);
        const action = [
          <Button
            color="inherit"
            size="small"
            onClick={() => this.props.closeSnackbar()}
          >
            Dismiss
          </Button>,
        ];
        // const data = {"data":{"gcm.notification.content_available":"true","key":"APP_NOTIFICATION"},"from":"222981039305","priority":"high","notification":{"title":"Sample Title","body":"{\"body\":\"Your are now in team Team B\"}"},"collapse_key":"do_not_collapse"}
        let BODY = "";
        let TITLE = "";
        let DATA = "";
        try {
          BODY = get(payload, "notification", "");
          console.log("BODY: ", BODY);
          DATA = JSON.parse(get(payload, "data.body", ""));

          get(payload, "data.key", "") == "REFRESH"
            ? (TITLE = "A message from SumHR")
            : (TITLE = get(
                this.props,
                "SubscriptionInfo.SubscriptionData.subscriptionname",
                "_ _",
              ).split(" ")[0]);
        } catch (err) {}
        this.props.enqueueSnackbar(`${TITLE}: ${BODY && BODY.body}`, {
          ...PARAMS,
          action,
          onClose: () => {
            console.log('get(payload, "data.key", ""): ', payload);
            if (get(payload, "data.key", "") == "SIGNOUT") {
              // this.props.LogMeOut(
              //   get(this.props, "AuthenticationAction.login.userid", ""),
              // );
            } else if (get(payload, "data.key", "") == "REFRESH") {
              localStorage.setItem("REFRESHED", true);
              window.location.reload(true);
            } else if (get(payload, "data.key", "") == "APP_NOTIFICATION") {
              this.getNotificationCount();
              this.props.PushNotificationActive(true);

              // if (DATA && DATA.islogout) {
              //   this.props.LogMeOut(
              //     get(this.props, "AuthenticationAction.login.userid", ""),
              //   );
              // }
            }
          },
          // onClick: () => {
          //   if (get(payload, "data.key", "") == "APP_NOTIFICATION") {
          //     window.open("https://weare.sumhr.io/");
          //   }
          // },
        });
      });
    } catch (err) {}
  }

  authenticateUser() {
    console.log(
      'get(this.props, "AuthenticationAction.login", ""): ',
      get(this.props, "AuthenticationAction.login", ""),
    );
    if (!get(this.props, "AuthenticationAction.login", "")) {
      // console.log("yyay");
      const { pathname } = window.location;
      let IsNewEmployeeeRoute = false;
      let INCLUDEROUTESTEMP = ["/newemployee"];
      INCLUDEROUTESTEMP.forEach((path) => {
        if (pathname.indexOf(path) > -1) {
          IsNewEmployeeeRoute = true;
        }
      });
      if (IsNewEmployeeeRoute) {
        if (
          !get(
            this.props,
            "SubscriptionInfo.SubscriptionData.employeeid",
            "",
          ) &&
          (pathname !== "/newemployee" || pathname === "/newemployee/")
        ) {
          window.open("/newemployee", "_self");
        }
      } else {
        INCLUDEROUTESTEMP = [
          "/login",
          "/subscriptionpasswordupdate",
          "/logasadmin",
          "/forgotpassword",
        ];
        let nonValidationRoute = false;
        INCLUDEROUTESTEMP.forEach((path) => {
          if (pathname.indexOf(path) > -1) {
            nonValidationRoute = true;
          }
        });
        if (
          !nonValidationRoute &&
          pathname != "/" &&
          pathname != "/subscriptionexpired"
        ) {
          // console.log("yu[s");
          localStorage.setItem("prevLink", pathname);
          window.open("/login", "_self");
        }
      }
    } else {
      // window.open("/login", "_self");
      // const loginData = get(this.props, "AuthenticationAction.login", "");
      // const SubscriptionData = get(this.props, "SubscriptionInfo.SubscriptionData", "");
      // LogRocket.identify("THE_USER_ID_IN_YOUR_APP", {
      //   name: loginData.fullname,
      //   // email: 'durvankur@sumhr.com',
      //   // Add your own custom user variables here, ie:
      //   subscriptionid: loginData.subscriptionid,
      //   subscriptionname: SubscriptionData.subscriptionname,
      //   employeeid: loginData.employeeid
      // });
    }
  }

  checkSubscriptionnStatus = (SubscriptionData) => {
    if (SubscriptionData.statusid == 4 || SubscriptionData.statusid == 7) {
      this.props.history.push("/trialexpired");
      // window.reload();
    } else if (
      SubscriptionData.statusid == 5 ||
      SubscriptionData.statusid == 6 ||
      SubscriptionData.statusid == 8
    ) {
      this.props.history.push("/subscriptionexpired");
    }
  };

  authenticateSubscription() {
    // if (
    //   !get(this.props, "SubscriptionInfo.SubscriptionData.subscriptionid", "")
    // ) {
    const subDomain = getSubdomain();
    // subDomain = "qualitykiosk"; //uncomment to run on firefox
    localStorage.setItem("selectedleaves", "");
    instance
      .get(`subscription/verifysubscription/${subDomain}`)
      .then((res) => {
        if (res.data) {
          this.setEnoughDataReceivedFlag(true);
          this.props.VerifySubscription(subDomain);
          this.checkSubscriptionnStatus(res.data.result[0]);
        } else {
          this.setEnoughDataReceivedFlag(true);
          this.checkSubscriptionnStatus(
            this.props.SubscriptionInfo.SubscriptionData,
          );
          setAppFavicon(
            get(this.props, "SubscriptionInfo.SubscriptionData.favicon", ""),
          );
        }
      })
      .catch((err) => {
        if (get(err, "response.status", "") == 404) {
          // window.open("http://www.sumhr.io", "_self");
          this.props.history.push("/typo");
          this.setState({ typoperrorcode: true });
        }
      });
    // }
  }

  storageChange(event) {
    if (event.key == "REFRESHED") {
      // window.location.reload(true);
      window.location.reload();
    }
    if (event.key == "loggedout") {
      window.sessionStorage.setItem("oldUrl", window.location.href);
      window.sessionStorage.setItem("oldUser", event.newValue);
      window.open("/login", "_self");
    }
    if (event.key == "loggedin") {
      if (event.newValue == window.sessionStorage.getItem("oldUser")) {
        const URL = window.sessionStorage.getItem("oldUrl");
        if (URL) {
          window.open(URL, "_self");
        }
      } else {
        window.close();
      }
    }
  }

  _showLeftDrawer() {
    const { AuthenticationAction } = this.props;
    const { pathname } = window.location;
    let result = false;
    if (AuthenticationAction.IsFulfilled) {
      INCLUDEROUTES.forEach((path) => {
        if (pathname.indexOf(path) > -1) {
          result = true;
        }
      });
      if (pathname.includes("request_center")) {
        result = true;
      } else if (pathname.includes("helpdesk")) {
        result = true;
      } else if (EXACTROUTES.indexOf(pathname) > -1) {
        result = true;
      }
    }
    return result;
  }

  _showRightDrawer(showLeftDrawer) {
    const {
      selectionReducer: { appMode },
    } = this.props;
    return showLeftDrawer && appMode != "config";
  }

  render() {
    const { enoughDataReceived } = this.state;
    const showLeftDrawer = this._showLeftDrawer();
    const {
      selectionReducer: { appMode },
    } = this.props;
    // const showRightDrawer = this._showRightDrawer(showLeftDrawer);
    const _rootClass = showLeftDrawer
      ? "root-wrapper-with-drawer"
      : "root-wrapper";
    const _navClass = showLeftDrawer
      ? get(this.props, "selectionReducer.openLeftDrawer", "")
        ? "top-navbar"
        : "top-navbar-closed"
      : "no-top-navbar";
    const showChangePassword =
      get(this.props, "AuthenticationAction.login.isfirstlogin", "") === true &&
      showLeftDrawer;

    // window.Beacon('init', 'a0e1e305-ff42-4890-ac11-0b536ed9b202');
    // window.Beacon('navigate', '/ask/chat');
    if (
      Configs.MODE == "PROD" &&
      this.props.AuthenticationAction.login &&
      !window.origin.includes("superuser") &&
      !window.origin.includes("signup") &&
      !window.origin.includes("accounts") &&
      (this.props.AuthenticationAction.login.masterprofileid == 9 ||
        this.props.AuthenticationAction.login.masterprofileid == 10 ||
        this.props.AuthenticationAction.login.masterprofileid == 11)
    ) {
      const {
        fullname,
        email,
        primarymobile,
        accountid,
        subscriptionid,
        designationname,
        imagepath,
        objsuportplan,
      } = this.props.AuthenticationAction.login;
      let subscriptionname = null;
      if (
        this.props.SubscriptionInfo &&
        this.props.SubscriptionInfo.SubscriptionData &&
        this.props.SubscriptionInfo.SubscriptionData.subscriptionname
      ) {
        subscriptionname =
          this.props.SubscriptionInfo.SubscriptionData.subscriptionname;
      }
      // const {subscriptionname} = this.props.SubscriptionInfo.SubscriptionData;
      window.Beacon("identify", {
        name: fullname,
        email,
        phone: primarymobile,
        company: subscriptionname,
        jobTitle: designationname,
        avatar: imagepath,
        account_id: accountid,
        subscription_id: subscriptionid,
        // signature: 'YOUR_SERVER_GENERATED_SIGNATURE_HERE',
      });
      if (
        objsuportplan &&
        (objsuportplan.typevalue == 3 ||
          objsuportplan.typevalue == 4 ||
          objsuportplan.typevalue == 5)
      ) {
        window.Beacon("navigate", "/ask/chat/");
      } else {
        window.Beacon("navigate", "/answers/");
      }
    }
    //  else {
    //   window.Beacon("destroy");
    // }
    else if (Configs.MODE == "DEV") {
      window.Beacon("destroy");
   } 
   else {
    
    //console.log("this.state.helpscoutarticleids", this.state.helpscoutarticleids);
    Beacon('config', { messagingEnabled: false })
    if(this.state.helpscoutarticleids) {
    Beacon('suggest',this.state.helpscoutarticleids)
  }
   }

    // window.Beacon('navigate', '/ask/message/');
    // window.Beacon('article');
    // window.Beacon('suggest', ['5ecbae682c7d3a5ea54bb289', '5ece4b4e2c7d3a3dea3d134e']);

    return (
      <If condition={enoughDataReceived}>
        <Suspense fallback={<Loader />}>
          <Dialog open={showChangePassword}>
            <ChangePassword {...this.props} />
          </Dialog>
          <Router>
            <Switch>
              <div className={`${_rootClass}`}>
                <div className="layout-container width100">
                  <div
                    container
                    className={`${_navClass}`}
                    style={appMode == "config" ? { paddingLeft: 250 } : {}}
                  >
                    {/* <If condition={showLeftDrawer}> */}
                    {showLeftDrawer && this.state.checkrecruitaccessapi && (
                      <CommonNavbar
                        notificationcount={this.state.notificationcount}
                        setNotification={this.setNotification}
                        ishiringmanager={this.state.ishiringmanager}
                        ishiringowner={this.state.ishiringowner}
                        isrecruiter={this.state.isrecruiter}
                        isparticipant={this.state.isparticipant}
                        isticketowner={this.state.isticketowner}
                      />
                    )}
                    {/* </If> */}
                    <div
                    // container
                    // className="content-wrapper"
                    >
                      <If condition={showLeftDrawer}>
                        <Navigation {...this.props} />
                      </If>
                    </div>
                    {/* <BeaconDevTools isAutoOpen beaconIds={[
                        { id: '1', label: 'My Test Beacon 1' },
                        { id: '2', label: 'Production Beacon' },
                        { id: '3', label: 'Marketing Beacon' },
                      ]} /> */}
                    <div>
                      <Route path="/config" component={ConfigRoutes} />
                      <Route path="/help" component={Help} />
                      <Route
                        path="/trialexpired"
                        component={TrialExpiredPage}
                      />
                      <Route
                        path="/subscriptionexpired"
                        component={SubscriptionExpiredPage}
                      />
                      {/* {this.state.typoperrorcode && ( */}
                      <Route path="/typo" component={TypoError} />
                      {/* )} */}
                      <Route
                        path="/planner"
                        render={(props) => <PlannerRoute {...props} />}
                      />
                      <Route
                        path="/live_data"
                        render={(props) => <LiveDataRoute {...props} />}
                      />
                      {/* {Configs.MODE === "DEV" && ( */}
                      <Route path="/policycenter" component={PolicyCenter} />
                      {/* )} */}
                      <Route path="/offercenter" component={Offercenter} />
                      <Route path="/attendance" component={Attendance} />
                      <Route path="/leave" component={Leaves} />
                      <Route path="/holiday" component={Holiday} />
                      <Route
                        path="/holiday/select_holiday"
                        component={SelectOptionalHoliday}
                      />
                      <Route path="/track" component={Track} />
                      {/* <Route exact path="/app/pay/expense" render={(props) => <Expense {...props} />} />
                      <Route
                        exact
                        color="primary"
                        path="/app/pay/expense/compensator"
                        render={(props) => <Expense {...props} />}
                      /> */}
                      {<Route path="/payroll" component={EmpPayroll} />}
                      <Route path="/app/track" component={Track} />
                      <Route
                        path="/app/organise"
                        component={OrganisationRoutes}
                      />
                      {<Route path="/app/pay" component={payrollRoutess} />}
                      {Configs.MODE === "DEV" && (
                        <Route path="/app/perform" component={performRoutes} />
                      )}

                      <Route
                        path="/app/resolve/checklist"
                        component={ChecklistManager}
                      />

                      <Route
                        exact
                        path="/forgotpassword"
                        component={SubscriptionForgotPassword}
                      />
                      <Route exact path="/login" component={SubscriptionApp} />
                      <Route exact path="/" component={SubscriptionApp} />
                      <Route
                        exact
                        path="/subscriptionpasswordupdate/:auditid/:userid"
                        component={UpdateSubscriptionPassword}
                      />
                      <Route
                        exact
                        path="/newemployee"
                        component={ProfileLandingPage}
                      />
                      <Route
                        exact
                        path="/newemployee/basic"
                        component={BasicEmpProfile}
                      />
                      <Route
                        exact
                        path="/newemployee/completeprofile"
                        component={EmpProfileBeforeJoining}
                      />
                      <Route
                        exact
                        path="/logasadmin"
                        component={LogInAsAdmin}
                      />
                      <Route
                        exact
                        path="/login/:token"
                        component={LogInAsSSO}
                      />
                      <Route exact path="/mobileview" component={MobileView} />
                      <Route exact path="/setconfig" component={ConfigMode} />
                      <Route
                        exact
                        path="/invite_new_employee"
                        component={InviteEmployee}
                      />
                      <Route
                        exact
                        path="/personal_privacy"
                        component={ProfilePrivacy}
                      />
                      {/* <Route
                        exact
                        path="/planner"
                        render={(props) => <Planner {...props} />}
                      /> */}
                      <Route
                        exact
                        path="/operations"
                        render={(props) => <Operations {...props} />}
                      />
                      {/* <Route
                        exact
                        path="/live_data"
                        render={(props) => <LiveData {...props} />}
                      /> */}
                      <Route
                        exact
                        path="/expense"
                        render={(props) => <ExpenseDashboard {...props} />}
                      />
                      <Route
                        exact
                        path="/profile"
                        component={MainProfilePage}
                      />
                      <Route
                        exact
                        path="/profile/:colleagueid"
                        component={MainProfilePage}
                      />
                      <Route exact path="/directory" component={Directory} />
                      <Route
                        exact
                        path="/reporting_hierarchy"
                        component={Reportee}
                      />
                      <Route
                        exact
                        path="/request_center"
                        component={RequestCenter}
                      />
                      <Route
                        exact
                        path="/request_center/sent"
                        component={RequestCenter}
                      />
                      <Route
                        exact
                        path="/request_center/received"
                        component={RequestCenter}
                      />
                      {
                        <Route
                          exact
                          path="/request_center/:requestcode"
                          component={RequestCenter}
                        />
                      }
                      <Route
                        exact
                        path="/request_center/notification/:requestcode/100"
                        component={RequestCenter}
                      />
                      {
                        <Route
                          exact
                          path="/request_center/:requestcode/:actionid"
                          component={DailyRequests}
                        />
                      }
                      <Route
                        exact
                        path="/downloadinvoice/:subscriptionseatid"
                        component={DownloadInvoice}
                      />
                      <Route
                        exact
                        path="/change_password"
                        component={ChangePwdTab}
                      />
                      <Route exact path="/report_robo" component={ReportRobo} />
                      <Route
                        exact
                        path="/notification_preferences"
                        component={NotificationSettings}
                      />
                      <Route
                        exact
                        path="/notification_center"
                        component={NotificationCenter}
                      />
                      <Route exact path="/storybook" component={Storybook} />
                      <Route exact path="/comingsoon" component={Comingsoon} />
                      <Route exact path="/desk" component={Home} />

                      <Route exact path="/calendar" component={Calendar} />

                      <Route exact path="/tt" component={tt} />
                      <Route
                        exact
                        path="/app/hris/dashboard"
                        component={HrisDashboard}
                      />
                      <Route exact path="/drive" component={HrDrive} />
                      {/* <Route exact path="/dashboard" component={Dashboard} /> */}
                      {/* <Route exact path="/reacttourdemo" component={ReactTour} /> */}
                      {
                        <Route
                          exact
                          path="/letter_box"
                          component={MyHrLetters}
                        />
                      }
                      {
                        // Configs.MODE === "DEV" &&
                        <Route exact path="/checklist" component={Checklist} />
                      }
                      {<Route exact path="/okr" component={MyGoals} />}
                      {<Route path="/360" component={Review} />}
                      {<Route path="/zero" component={Review} />}
                      {<Route path="/myresults" component={Review} />}
                      {<Route path="/pendingreviews" component={Review} />}
                      {<Route path="/submittedreviews" component={Review} />}
                      {
                        <Route
                          exact
                          path="/app/perform/360/form"
                          component={ReviewManager}
                        />
                      }
                      {
                        <Route
                          exact
                          path="/app/perform/360/employee"
                          component={ReviewManager}
                        />
                      }

                      {/* <Route path="/app/recruit" component={Recruit} /> */}
                      <Route
                        path="/app/recruit"
                        render={(props) => (
                          <Recruit
                            {...props}
                            ishiringmanager={this.state.ishiringmanager}
                            ishiringowner={this.state.ishiringowner}
                            isrecruiter={this.state.isrecruiter}
                            isparticipant={this.state.isparticipant}
                          />
                        )}
                      />

                      {Configs.MODE === "DEV" && (
                        <Route
                          path="/app/careerpage"
                          component={SubscriptionCareerPage}
                        />
                      )}
                      <Route
                        // exact
                        path="/app/helpdesk"
                        component={HelpdeskManager}
                      />

                      <Route
                        // exact
                        path="/helpdesk"
                        component={Helpdesk}
                      />

                      <Route
                        exact
                        color="primary"
                        path="/downloadfromurl/:filename/:url/:isdb?"
                        component={DownloadPayslip}
                      />

                      <Route
                        exact
                        path="/app/hrops/assets"
                        component={Assets}
                      />

                      <Route exact path="/app/perform/okr" component={OKR} />

                      {/*
                        <Route path="**" component={PageNotFound} />
                        <Route exact path="/empcodepreview" component={EmpCodePreview} />
                        <Route path="/business-config" component={BusinessConfigRoutes} />
                        <Route exact path="/approval_workflow" component={ApprovalWorkflow} />
                        <Route exact path="/approval_workflow/:workflowid" component={ApprovalWorkflow} />
                        <Route exact path="/approvalworkflowlist" component={ApprovalWorkflowList} />
                        <Route exact path="/defaultPermissions" component={DefaultPermissions} />
                        <Route exact path="/permissionPolicy" component={PermissionPolicy} />
                        <Route exact path="/permissionsettings/:commodityid/:profileid" component={PermissionSettings} />
                        <Route exact path="/404" component={PageNotFound} />
                        <Route path="**" component={PageNotFound} />
                        {showRightDrawer ? <RightNavigation {...this.props} /> : null}
                        */}
                      <DirectoryDrawer />
                    </div>
                  </div>
                </div>
              </div>
            </Switch>
          </Router>
        </Suspense>
      </If>
    );
  }
}

function mapStateToProps(state) {
  return {
    SubscriptionInfo: state.SubscriptionInfo,
    AuthenticationAction: state.AuthenticationAction,
    pushnotificationsactive: state.pushnotificationsactive,
    Onboarding: state.Onboarding,
    selectionReducer: state.selectionReducer,
    FCMReducer: state.FCMReducer,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      VerifySubscription: (data) => VerifySubscription(data),
      LogMeOut,
      SetSubscriptionData: (data) => SetSubscriptionData(data),
      CommonReducerAction: (type, data) => CommonReducerAction(type, data),
      clockin,
      updateAuthentication,
      SetAppMode,
      PushNotificationActive,
      SetDrawerID,
    },
    dispatch,
  );
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withSnackbar(RootContainer)),
);
